// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3PLDK","inputWrap":"styles_inputWrap__2Tn8U","input":"styles_input__VAO5j"};